import React, { useState, useEffect } from "react";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";

const HeroSection = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const heroSlides = [
        {
            id: 1,
            image: "/assets/images/huancayo.jpg",
            link:"https://www.instagram.com/p/DZxnLhmy6EY/?hl=es-la"
        },
        {
            id: 2,
            image: "/assets/images/talleres_8.jpeg",
            link: "/coach/8"
        },
        {
            id: 3,
            image: "/assets/images/casa-elige-a-ti.jpg",
            link: "/books/2"
        },

    ];

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
        }, 7500);
        return () => clearInterval(timer);
    }, [currentSlide]);

    const goToSlide = (index) => setCurrentSlide(index);
    const currentHero = heroSlides[currentSlide];

    return (
        <section className="relative h-[55vh] lg:h-[60vh] overflow-hidden">
            {/* Imagen envuelta en <a> si hay link */}
            {currentHero?.link ? (
                <a
                    href={currentHero.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="absolute inset-0 block"
                >
                    <Image
                        src={currentHero.image}
                        alt={currentHero.title || "Hero Slide"}
                        className="w-full h-full object-contain object-center"
                    />
                </a>
            ) : (
                <div className="absolute inset-0">
                    <Image
                        src={currentHero.image}
                        alt={currentHero.title || "Hero Slide"}
                        className="w-full h-full object-contain object-center"
                    />
                </div>
            )}

            {/* Slide Indicators */}
            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex gap-2">
                {heroSlides.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => setCurrentSlide(index)}
                        className={`h-2 rounded-full transition-all duration-300 ${
                            index === currentSlide
                                ? "w-8 bg-historical-gold"
                                : "w-2 bg-white/40"
                        }`}
                        aria-label={`Ir a slide ${index + 1}`}
                    />
                ))}
            </div>


            {/* Navigation Arrows */}
            <div className="absolute inset-0 flex items-center justify-between container mx-auto px-4 sm:px-6 lg:px-8 z-20 pointer-events-none">
                <button
                    onClick={() =>
                        goToSlide(
                            (currentSlide - 1 + heroSlides.length) % heroSlides.length
                        )
                    }
                    className="pointer-events-auto left-4 lg:left-8 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-black/70 hover:bg-black rounded-full flex items-center justify-center"
                    aria-label="Diapositiva anterior"
                >
                    <Icon name="ChevronLeft" size={24} className="text-white" />
                </button>

                <button
                    onClick={() => goToSlide((currentSlide + 1) % heroSlides.length)}
                    className="pointer-events-auto right-4 lg:right-8 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-black/70 hover:bg-black rounded-full flex items-center justify-center"
                    aria-label="Siguiente diapositiva"
                >
                    <Icon name="ChevronRight" size={24} className="text-white" />
                </button>
            </div>
        </section>
    );
};

export default HeroSection;
